module.exports = __webpack_public_path__ + "img/9北极星会展网.442dcc29.png";